import { Theme } from '@material-ui/core';

export const zIndex = {
  rightSidebar: 1200,
  modal: 1300,
  tooltip: 1500,
  loadingSpinner: 3000,
  contractSignatureComponent: 2,
  channelsListMobileOverlay: 10,
};

declare module '@material-ui/core/styles' {
  export interface CustomTheme extends Theme {
    zIndex: Theme['zIndex'] & {
      contractSignatureComponent: number;
    };
  }
}
declare module '@mui/material/styles' {
  interface ZIndex {
    rightSidebar: number;
    contractSignatureComponent: number;
    loadingSpinner: number;
    channelsListMobileOverlay: number;
  }
}
